import { createValidity } from '@mhub/web-validations';
// Saved projects keep their duration; new projects preview the launch-derived default.
export const initialSRBExpiry = (project) => {
 if (project.id) return project.srbStoreyPlanExpiryMinutes;
 const n = typeof project.launchModeMinutes === 'string' ? Number(project.launchModeMinutes) : project.launchModeMinutes;
 return project.isLaunchMode && Number.isInteger(n) && n >= 1 ? Math.min(n, 30) : 10;
};
export const currentSRBExpiry = (project, edited) =>
 project.id || edited ? project.srbStoreyPlanExpiryMinutes : initialSRBExpiry(project);

export const validSRBExpiry = value =>
 (typeof value === 'number' || typeof value === 'string') &&
 String(value).trim() !== '' && Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 30;

export const srbExpirySubmission = (project, edited, canEdit) => {
 if (!canEdit || (!project.id && !edited)) return { omit: true };
 if (!validSRBExpiry(project.srbStoreyPlanExpiryMinutes)) return { block: true };
 return { value: Number(project.srbStoreyPlanExpiryMinutes) };
};

export const validateSRBExpiry = (value, options = {}) => {
 const validity = createValidity(options.key || 'srbStoreyPlanExpiryMinutes');
 if (!validSRBExpiry(value)) { validity.isValid = false; validity.message = options.message || 'Enter a whole number from 1 to 30 minutes.'; }
 return validity;
};



// WEBPACK FOOTER //
// ./src/utils/srbChartExpiry.js